import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { navLinks } from "../../data";
import {
  Hero,
  Container,
  HeroTop,
  LogoWrap,
  Logo,
  TratiCardWrap,
  TratiCard,
  TratiPoster,
  TratiPlayButton,
  LinkStack,
  BibleVerse,
  NavDivider,
  NavPill,
  MobileLoginButton,
  MobileLoginOverlay,
  MobileLoginModal,
  MobileLoginClose,
  MobileLoginActions,
  MobileLoginLogo,
  HeroBottom,
  CopyBlock,
  Heading,
  Subheading,
  PrimaryCta,
  FooterSpacer,
} from "./styles";

const isExternalLink = (href) => /^https?:\/\//.test(href || "");
const TRATI_VIDEO_ID = "ocV-wDEhrL4";
const TRATI_VIDEO_POSTER = "/novas-imagens/section-one/trati-video-poster.png";

export default function HeroSection({ onOpenFindProfessional }) {
  const navigate = useNavigate();
  const tratiVideoRef = React.useRef(null);
  const [mobileLoginOpen, setMobileLoginOpen] = React.useState(false);
  const [tratiVideoOpen, setTratiVideoOpen] = React.useState(false);

  const startTratiVideo = React.useCallback(() => {
    const playerWindow = tratiVideoRef.current?.contentWindow;

    if (!playerWindow) return;

    playerWindow.postMessage(
      JSON.stringify({ event: "command", func: "seekTo", args: [1.5, true] }),
      "*"
    );
    playerWindow.postMessage(
      JSON.stringify({ event: "command", func: "playVideo", args: [] }),
      "*"
    );
  }, []);

  const handleNavClick = (item) => {
    setMobileLoginOpen(false);

    if (item.action === "findProfessional") {
      onOpenFindProfessional();
      return;
    }

    if (isExternalLink(item.href)) {
      window.open(item.href, "_blank", "noopener,noreferrer");
      return;
    }

    navigate(item.href);
  };

  return (
    <Hero>
      <BibleVerse>
        <span>“Até aqui nos ajudou o Senhor.”</span>
        <strong>1 Samuel 7:12</strong>
      </BibleVerse>

      <Container>
        <HeroTop>
          <LogoWrap>
            <Logo src="/novas-imagens/logo.png" alt="Trataz" />
          </LogoWrap>

          <TratiCardWrap>
            <TratiPoster src={TRATI_VIDEO_POSTER} alt="Video da Trati" />
            {tratiVideoOpen && (
              <TratiCard
                ref={tratiVideoRef}
                src={`https://www.youtube.com/embed/${TRATI_VIDEO_ID}?playsinline=1&rel=0&enablejsapi=1`}
                title="Video da Trati"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                onLoad={() => window.setTimeout(startTratiVideo, 450)}
              />
            )}
            {!tratiVideoOpen && (
              <TratiPlayButton
                type="button"
                aria-label="Assistir video da Trati"
                onClick={() => setTratiVideoOpen(true)}
              />
            )}
          </TratiCardWrap>

          <LinkStack>
            {navLinks.map((item, index) => (
              <React.Fragment key={item.label}>
                {index === 2 && <NavDivider />}
                {item.action === "findProfessional" ? (
                  <NavPill
                    as="button"
                    type="button"
                    $active={item.active}
                    onClick={() => handleNavClick(item)}
                  >
                    {item.label}
                  </NavPill>
                ) : (
                  <NavPill
                    as="button"
                    type="button"
                    $active={item.active}
                    onClick={() => handleNavClick(item)}
                  >
                    {item.label}
                  </NavPill>
                )}
              </React.Fragment>
            ))}
          </LinkStack>

          <MobileLoginButton
            type="button"
            onClick={() => setMobileLoginOpen(true)}
          >
            FAZER LOGIN
          </MobileLoginButton>
        </HeroTop>

        {mobileLoginOpen && (
          <MobileLoginOverlay
            role="presentation"
            onClick={() => setMobileLoginOpen(false)}
          >
            <MobileLoginModal
              role="dialog"
              aria-modal="true"
              aria-label="Opções de acesso"
              onClick={(event) => event.stopPropagation()}
            >
              <MobileLoginClose
                type="button"
                aria-label="Fechar opções de acesso"
                onClick={() => setMobileLoginOpen(false)}
              >
                ×
              </MobileLoginClose>

              <MobileLoginActions>
                {navLinks.map((item, index) => (
                  <React.Fragment key={item.label}>
                    {index === 2 && <NavDivider />}
                    <NavPill
                      as="button"
                      type="button"
                      $active={item.active}
                      $width={item.width}
                      onClick={() => handleNavClick(item)}
                    >
                      {item.label}
                    </NavPill>
                  </React.Fragment>
                ))}
              </MobileLoginActions>

              <MobileLoginLogo
                src="/novas-imagens/popup-planos/tratazLogo.png"
                alt="Trataz"
              />
            </MobileLoginModal>
          </MobileLoginOverlay>
        )}

        <HeroBottom>
          <CopyBlock>
            <Heading>O TRATAMENTO NÃO TERMINA NA CONSULTA</Heading>

            <PrimaryCta
              as={Link}
              to="https://www.trataz.com.br/login"
              target="_blank"
              rel="noopener noreferrer"
              $variant="orange"
            >
              COMEÇAR GRATUITAMENTE
            </PrimaryCta>
          </CopyBlock>

          <Subheading>
            A TRATAZ CONECTA PROFISSIONAL E PACIENTE COM ACOMPANHAMENTO CONTÍNUO
            E INTELIGENTE.
          </Subheading>
        </HeroBottom>
        <FooterSpacer />
      </Container>
    </Hero>
  );
}
